import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

export interface ICompany {
    getAll(options: ODataOptions, jwt: string): Promise<object>;
    get(id: number, jwt: string): Promise<object>;
}

export default class Company extends BaseApi implements ICompany {
    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
        this.get = this.get.bind(this);
    }

    public getAll(options: ODataOptions, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1_0/companies${options.toString()}`, jwt);
    }

    public get(id: number, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1_0/companies/${id}`, jwt);
    }
}



// WEBPACK FOOTER //
// ./src/api/Company.ts